import React, { useEffect } from "react";

import { AuthRoutes } from "./Auth.Routes";
import { CartorioRoutes } from "./Cartorio.Routes";
import { useCartorio } from "../Hooks/cartorio";
import { useFuncionarioCartorio } from "../Hooks/funcionarioCartorio";
import { FuncionarioCartorioRoutes } from "./Funcionario_Cartorio.Routes";
import { PrefeituraRoutes } from "./Prefeitura.Routes";
import { usePrefeitura } from "../Hooks/usePrefeitura";
import { useFuncionarioPrefeitura } from "../Hooks/funcionarioPrefeitura";
import { Funcionario_PrefeituraRoutes } from "./Funcionario_Prefeitura.Routes";

export function Routes() {
  const { cartorioIsLogged, cartorio } = useCartorio();
  const { funcionarioCartorioIsLogged } = useFuncionarioCartorio();
  const { prefeituraIsLogged } = usePrefeitura();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();

 //const baseUrl = "http://localhost:3000";
 const baseUrl = "https://solucoes.sinsoft.com.br";

  // useEffect(() => {
  //   if (
  //     prefeituraIsLogged &&
  //     window.location.href != `${baseUrl}/itbi/prefeitura`
  //   )
  //     window.location.href = `${baseUrl}/itbi/prefeitura`;
  // }, [prefeituraIsLogged]);

  // useEffect(() => {
  //   if (cartorioIsLogged && window.location.href != `${baseUrl}/itbi/cartorio`)
  //     window.location.href = `${baseUrl}/itbi/cartorio`;
  // }, [cartorioIsLogged]);

  // useEffect(() => {
  //   if (
  //     funcionarioCartorioIsLogged &&
  //     window.location.href != `${baseUrl}/itbi/cartorio/funcionario`
  //   )
  //     window.location.href = `${baseUrl}/itbi/cartorio/funcionario/`;
  // }, [funcionarioCartorioIsLogged]);

  // useEffect(() => {
  //   if (funcionarioPrefeituraIsLogged)
  //     if (window.location.href != `${baseUrl}/itbi/prefeitura/funcionario`)
  //       window.location.href = `${baseUrl}/itbi/prefeitura/funcionario`;
  // }, [funcionarioPrefeituraIsLogged]);

  useEffect(() => {
    if (
      funcionarioCartorioIsLogged ||
      funcionarioPrefeituraIsLogged ||
      cartorioIsLogged ||
      prefeituraIsLogged
    ) {
      if (window.location.pathname.indexOf("itbi/inicio") != -1) {
        return;
      }

      if (window.location.href.indexOf("/itbi/redirecionamento") == -1) {
        window.location.href = `${baseUrl}/itbi/redirecionamento/${window.location.pathname.replaceAll(
          "/",
          "_"
        )}`
      }
    }
  }, [
    funcionarioCartorioIsLogged,
    funcionarioPrefeituraIsLogged,
    cartorioIsLogged,
    prefeituraIsLogged,
  ]);

  return (
    <>
      {cartorioIsLogged ? <CartorioRoutes /> : ""}

      {funcionarioCartorioIsLogged ? <FuncionarioCartorioRoutes /> : ""}

      {prefeituraIsLogged ? <PrefeituraRoutes /> : ""}

      {funcionarioPrefeituraIsLogged ? <Funcionario_PrefeituraRoutes /> : ""}

      {!funcionarioPrefeituraIsLogged &&
      !prefeituraIsLogged &&
      !funcionarioCartorioIsLogged &&
      !cartorioIsLogged ? (
        <AuthRoutes />
      ) : (
        ""
      )}
    </>
  )
}
